import {MutationTree} from 'vuex';
import ILocalState from './stateInterface';
import {CpcCodes} from '@/interfaces/CpcCodes';
import {ProductReport} from '@/interfaces/ProductReport';

const mutations: MutationTree<ILocalState> = {
    setProductCodeSystemList(state, payload) {
        state.productCodeSystemList = payload;
    },
    setSearchResults(state, payload) {
        state.productSearchResults = payload;
    },
    setFilteredSearchResults(state, payload) {
        state.filteredSearchResults = payload;
    },
    setFilterOptions(state, payload) {
        state.filterOptions = payload;
    },
    setSearchKeywords(state, payload) {
        state.searchKeywords = payload;
    },
    setSingleFolder(state, payload) {
        state.singleFolder = payload;
    },
    setExpandViaCpcs(state, payload) {
        state.expandViaCpcs = payload;
    },
    setSearchCpcs(state, payload) {
        state.searchCpcs = payload;
    },
    setSavedSearches(state, payload) {
        state.savedSearches = payload;
    },
    setFilterData(state, payload) {
        state.filterData = Object.assign({}, payload);
    },
    setTotalResults(state, payload) {
        state.totalResults = payload;
    },
    setTechnologyTotalItems(state,payload){
        state.technologyTotalItems=payload.data[0].attributes.value
    },
    setSoftwareTotalItems(state,payload){
        state.softwareTotalItems=payload.data[0].attributes.value
    },
    setGoodwillTotalItems(state,payload){
        state.goodwillTotalItems=payload.data[0].attributes.value
    },
    setTrademarkTotalItems(state,payload){
        state.trademarkTotalItems=payload.data[0].attributes.value
    },
    setCustomerTotalItems(state,payload){
        state.customerTotalItems=payload.data[0].attributes.value
    }
};

export default mutations;
